import * as React from 'react'
import { Box, Typography } from '@mui/material'
import { List, DatagridConfigurable, TextField, Link, FunctionField } from 'react-admin'
import Empty from '../../common/Empty'
import { useProviderContext } from '../../../context/ProviderContext'

const ProvidersList = (props) => {
  const { setProviderInfo, providerInfo } = useProviderContext()

  return (
    <List
      {...props}
      resource="provider-portal/providers"
      filter={{ _order: 'DESC' }}
      actions={false}
      pagination={false}
      empty={
        <Empty
          text={
            <>
              Request for access pending. Contact <a href="mailto:providers@malefromhome.com">providers@malefromhome.com</a> for
              assistance.
            </>
          }
        />
      }
    >
      <Box sx={{ p: 3, pb: 1 }}>
        <Typography variant="h4" gutterBottom>
          Provider Results
        </Typography>
        <Typography paragraph>
          Select a provider below to view provider-specific results and actions available to your account.
        </Typography>
      </Box>
      <DatagridConfigurable
        bulkActionButtons={false}
        sx={{
          '& .MuiTableCell-head': {
            fontWeight: 700,
          },
          '& .MuiTableCell-head .MuiTypography-root': {
            fontWeight: 700,
          },
        }}
      >
        <TextField label="Provider (Clinic)" source="displayName" />
        <FunctionField
          label="Show"
          render={(record) => (
            <Link
              to={`/provider-portal/results/${record.id}`}
              onClick={() =>
                setProviderInfo({
                  id: record.id,
                  displayName: record.displayName,
                  kitRequestsEnabled: providerInfo.kitRequestsEnabled,
                })
              }
            >
              <span className="fa-solid fa-eye"></span> SHOW
            </Link>
          )}
        />
      </DatagridConfigurable>
    </List>
  )
}

export default ProvidersList
